import ItemMaster from 'App/ItemMaster';
import { CAT_TYPES } from '@/app/utils/Collections';

export async function searchProductTypes(term, filters = {}) {
  const items = await ItemMaster.getList({
    category: CAT_TYPES,
    filter: {
      'translations.name': term,
      relevantOrder: 'name',
      ...filters,
    },
  });
  // Filter machinery dedupes options by `value` and resolves chip labels by
  // `value`/`text`, while the Vuetify dropdown reads `id`/`name` (see fieldConf.attrs).
  // ItemMaster returns proxied BaseModel instances, so flatten to a plain object
  // carrying both pairs — otherwise a spread drops the proxied id/name.
  return (items || []).map((item) => ({ ...item.props, value: item.id, text: item.name }));
}
